/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RedeliverWebhookDeliveryRequest
 */
export interface RedeliverWebhookDeliveryRequest {
  /**
   *
   * @type {string}
   * @memberof RedeliverWebhookDeliveryRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof RedeliverWebhookDeliveryRequest
   */
  deliveryId: string;
}

/**
 * Check if a given object implements the RedeliverWebhookDeliveryRequest interface.
 */
export function instanceOfRedeliverWebhookDeliveryRequest(
  value: object,
): value is RedeliverWebhookDeliveryRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("deliveryId" in value) || value["deliveryId"] === undefined)
    return false;
  return true;
}

export function RedeliverWebhookDeliveryRequestFromJSON(
  json: any,
): RedeliverWebhookDeliveryRequest {
  return RedeliverWebhookDeliveryRequestFromJSONTyped(json, false);
}

export function RedeliverWebhookDeliveryRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RedeliverWebhookDeliveryRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    deliveryId: json["deliveryId"],
  };
}

export function RedeliverWebhookDeliveryRequestToJSON(
  json: any,
): RedeliverWebhookDeliveryRequest {
  return RedeliverWebhookDeliveryRequestToJSONTyped(json, false);
}

export function RedeliverWebhookDeliveryRequestToJSONTyped(
  value?: RedeliverWebhookDeliveryRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    deliveryId: value["deliveryId"],
  };
}
